const r = "breadcrumbs", b = "breadcrumbs__item", e = "breadcrumbs__text", s = "breadcrumbs__icon", c = {
  breadcrumbs: r,
  "breadcrumbs__item-list": "breadcrumbs__item-list",
  breadcrumbs__item: b,
  breadcrumbs__text: e,
  breadcrumbs__icon: s
};
export {
  r as breadcrumbs,
  s as breadcrumbs__icon,
  b as breadcrumbs__item,
  e as breadcrumbs__text,
  c as default
};
